import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';

import style from './style.less';

import CardHeader from '../../pieces/card-header';
import { fetchFeed } from '../../../lib/data';
import { shuffle } from '../../../lib/utils';

import { Icon } from '@cube/blocks';
import { trackingProvider, trackProps, DIMENSION } from '@cube/track';

/**
 * A list of external links
 * @param {Object}  items the links to render
 * @param {String}  title the title of the cluster
*/
@trackingProvider({
	[DIMENSION.componentpath]: 'LinksCluster'
})
export default class LinksCluster extends Component {

	state = {
		loading: true,
		error: false,
		items: []
	};

	getLinks = (props) => fetchFeed({
		...props
	})
		.then( res => {
			if (res.cards && res.cards.length > 0) {
				this.setState({
					items: res.cards,
					loading: false,
					error: false
				});
				return;
			}
			this.setState({
				loading: false,
				error: true
			});
		})
		.catch( error => {
			this.setState({
				loading: false,
				error: true
			});
		});

	componentWillMount() {
		if (this.props.items && this.props.items.length > 0) {
			this.setState({
				items: (this.props.shuffle ? shuffle(this.props.items) : this.props.items),
				loading: false
			});
			return;
		}
		if (this.props.feed) this.getLinks(this.props);
	}

	render({ title, clusterClass, layout, qeId, mode, titleLink, ...props }, { items, loading, error }) {
		if ((loading || error) && (!items || items.length === 0)) return;

		return (
			<div class={cx(style.linksCluster, clusterClass, style[mode], style[layout])} qid={qeId}>
				{ title && <CardHeader title={title} qeId={qeId} theme={mode==='colorful' ? 'dark' : 'light'} link={titleLink} /> }
				<div class={style.links}>
					{ items.map((item, i) => (
						<div class={style.link} qid={qeId + '-item-' + i}>
							<a href={dlv(item, 'link.href')} target={dlv(item, 'link.open_new_window') ? '_blank' : '_self'}
								rel="noopener noreferrer"
								{...trackProps({
									[DIMENSION.contenttitle]: item.title,
									[DIMENSION.clickindex]: i+1
								}, this.context)}
							>
								<span>{item.title}</span>
								<Icon name="navigate-right-cube" class={style.icon} />
							</a>
						</div>
					)) }
				</div>
			</div>
		);
	}
}
